export const HUBSPOT_ORG_ID = 6658395;
export const HUBSPOT_URL = "https://app.hubspot.com";
